var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnounce({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "gen_announc") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.333,87.5H100v66.666H83.333A33.195,33.195,0,0,1,50,120.833,33.195,33.195,0,0,1,83.333,87.5ZM125,195.833q0,18.926,8.854,47.569a8.377,8.377,0,0,1-7.986,10.764h-15.8q-6.079,0-7.812-5.555-10.591-32.292-10.59-52.778,0-3.646-4.167-9.9a76.845,76.845,0,0,0-8.333-10.591L75,170.833h41.667q10.586,0,23.958,1.216Q125,188.369,125,195.833ZM116.667,87.5a252.207,252.207,0,0,0,39.844-3.038,243.493,243.493,0,0,0,30.034-6.337,135.393,135.393,0,0,0,22.743-9.288q11.719-5.99,14.236-7.726t8.246-5.9a6.421,6.421,0,0,1,3.646-1.042h6.25A8.3,8.3,0,0,1,250,62.5V179.166a8.3,8.3,0,0,1-8.333,8.334h-6.25a6.421,6.421,0,0,1-3.646-1.042q-5.729-4.166-8.246-5.9t-14.236-7.726a135.647,135.647,0,0,0-22.743-9.289,244.436,244.436,0,0,0-30.034-6.336,252.437,252.437,0,0,0-39.844-3.039Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnounce);
export default __webpack_public_path__ + "static/media/announce.699adbeb3dbe2913d6c9f17ff2c91f31.svg";
export { ForwardRef as ReactComponent };